module.exports = __webpack_public_path__ + "img/gmailPage.448eb54f.jpg";